import React, { FunctionComponent, useCallback } from 'react';
import { DragDropContext, Draggable, Droppable, DropResult } from 'react-beautiful-dnd';
import { useScrollCancelDrag } from '../../../../../../../utils/useScrollCancelDrag';
import { ScoreRow } from '../ScoreRow';
import { ISortableScoreListProps } from './types';

export const SortableScoreList: FunctionComponent<ISortableScoreListProps> = ({
  rows,
  filterId,
  onScoreSelection,
  selectedScoreIds,
  onReorder,
}) => {
  const { sensors, handleDragStart, handleDragEnd } = useScrollCancelDrag();

  const handleDrop = useCallback(
    (result: DropResult) => {
      handleDragEnd();
      if (result.reason === 'CANCEL' || !result.destination) {
        return;
      }
      if (result.source.index === result.destination.index) {
        return;
      }

      const rowId = result.draggableId;
      const sourceIndex = result.source.index;
      const destinationIndex = result.destination.index;

      const newRows = [...rows];
      newRows.splice(sourceIndex, 1);
      newRows.splice(destinationIndex, 0, rowId);
      onReorder(newRows);
    },
    [rows, handleDragEnd, onReorder],
  );

  return (
    <DragDropContext sensors={sensors} onDragStart={handleDragStart} onDragEnd={handleDrop}>
      <Droppable droppableId={'scores'} direction="vertical" type="column">
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {rows.map((scoreId, index) => (
              <Draggable key={`draggable-row-${scoreId}`} draggableId={scoreId} index={index}>
                {(provided) => (
                  <div {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}>
                    <ScoreRow
                      key={scoreId}
                      scoreId={scoreId}
                      filterId={filterId}
                      onCheckboxChange={onScoreSelection}
                      isSelected={selectedScoreIds.includes(scoreId)}
                    />
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};
